<template>
  <table class="table-a timelogs-table">    
      
        <tr>
          <th></th>
          <th>Dato</th>
          <th>Tid</th>
          <th>Opgave</th>
          <th>Type</th>
          <th>Note</th>
          <th></th>
          <th></th>
        </tr>
      
      
        <template v-for="(timelog,i) in timelogs_dataloaded">
          <tr v-if="separate_dates && timelogListDateSpacerBoolean(timelogs,i)" :key="'tf23'+i">
            <td colspan="9" class="timelog-date-spacer"> </td>
          </tr>
          <tr> 
            <td><avatar :text="timelog.user.email | milkinitials"></avatar></td>
            <td v-if="false"><avatar :input="timelog.user"></avatar></td>
            <td>
              {{ nicedate(timelog.date, 'ddd D/M-YY') | weekday1dk }}
            </td>
            <td>
              {{timelog.hours}} t
            </td>
            <td>
              <router-link class="textlink" :to="'/project/'+timelog.project.key" v-if="timelog.project">{{timelog.project.name}}</router-link>
              <br>
              <router-link class="textlink" :to="'/client/'+timelog.client.key" v-if="timelog.client">{{timelog.client.name}}</router-link>
            </td>
            <td>
              {{translateWorktype(timelog.worktype)}}
            </td>
            <td>
              {{timelog.title}}
            </td>
            <td>
              <div class="textlink" @click="editTimelog(timelog)">
                <svgicon icon="linearicons/pencil"></svgicon>
              </div>
            </td>
            <td>
              <div class="textlink" @click="delete_timelog(timelog)">
                <svgicon icon="linearicons/trash"></svgicon>
              </div>
            </td>
    			</tr>
        </template>
      
		</table>
</template>

<script>
import helpers from '../helpers.js';
import globals from '../globals.js';
import mixins from '../mixins.js';
import moment from 'moment'
import Avatar from '.././components/Avatar'
export default {
  components: { Avatar },
  props: [ 'timelogs' ],

  mixins: [ mixins.db, mixins.generic ],
  
  data: function () { return {      

    separate_dates: false,

  }},

  computed:{

    timelogs_dataloaded(){

      var timelogs = this.timelogs

      for( let timelog of timelogs ) {
        if( !timelog.project && timelog.project_key ) timelog.project = this.getOne('project',timelog.project_key)
        if( !timelog.client && timelog.client_key )   timelog.client = this.getOne('client',timelog.client_key)
        if( !timelog.user && timelog.user_key )   timelog.user = this.getOne('user',timelog.user_key)
      }

      return timelogs

    },
    
  },

  methods: {
    
    delete_timelog: helpers.delete_timelog,
    translateWorktype: helpers.translateWorktype,

    timelogListDateSpacerBoolean(filteredTimelogs,i){
      if(i==0) return false
      var timelog = filteredTimelogs[i]
      var timelog_prev = filteredTimelogs[i-1]
      return (timelog.date != timelog_prev.date)
    },

    editTimelog(timelog){
      globals.modal_timelog_edit.timelog = timelog
      globals.modal_timelog_edit.active = true
    },

    gotoClient(input){
      var a = 'client/', b
      if( typeof input == 'string' ) b = input
      if( typeof input != 'string' ) b = input['.key']
      this.$router.push(a+b)
    },

    getUserInitials(key){ var user = this.getUser(key); return user.email.replace('@milk-studio.dk','') },

    nicedate(date, format){
      if( !format ) format = 'YYYY-MM-DD'
      return moment(date,'YYYY-MM-DD').format(format)
    },

  },

  created(){


  },

}
</script>



// WEBPACK FOOTER //
// TimelogsList.vue?200aa418